__turbopack_context__.v({
  "buttonsAnimation": "genericCtaBlock-module__Z7Focq__buttonsAnimation",
  "contentAnimation": "genericCtaBlock-module__Z7Focq__contentAnimation",
  "fadeInUp": "genericCtaBlock-module__Z7Focq__fadeInUp",
  "headerAnimation": "genericCtaBlock-module__Z7Focq__headerAnimation",
  "sectionAnimation": "genericCtaBlock-module__Z7Focq__sectionAnimation",
});
